export default __webpack_public_path__ + "static/img_growing_together_1-2e8d397998bc105982b4c662199d6a44.png";